<template>
  <button @click="handleExport" class="btn-export" :disabled="loading">
    {{ loading ? 'Export...' : 'Exporter' }}
  </button>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useHypothesesStore } from '@stores/hypotheses.store';

const hypothesesStore = useHypothesesStore();
const loading = ref(false);

const handleExport = () => {
  if (!hypothesesStore.currentHypothesis) {
    alert('Veuillez sélectionner une hypothèse');
    return;
  }
  const blocks = hypothesesStore.currentHypothesis?.blocks ?? [];
  if (blocks.length === 0) {
    alert('Aucun bloc sur le canvas à exporter');
    return;
  }

  loading.value = true;
  const onDone = () => {
    loading.value = false;
    window.removeEventListener('canvas-export-done', onDone);
  };
  window.addEventListener('canvas-export-done', onDone);
  window.dispatchEvent(new CustomEvent('canvas-export-fitted'));
};
</script>

<style scoped>
.btn-export {
  padding: 0.5rem 1rem;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
}

.btn-export:hover:not(:disabled) {
  background-color: #218838;
}

.btn-export:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
